// When the deployed build changes, a tab still running the old bundle asks
// the server for lazy chunks that no longer exist (HTTP 404/500), which
// webpack surfaces as an uncaught ChunkLoadError. Recover by dropping the
// stale service worker and reloading once so the tab picks up the new
// index.html and chunk manifest.
const RELOAD_FLAG = 'ir-chunk-load-reload';

function storageGet(win: Window, key: string): string | null {
  try {
    return win.sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function storageSet(win: Window, key: string, value: string): void {
  try {
    win.sessionStorage.setItem(key, value);
  } catch {
    // storage unavailable (private mode) - the reload still helps
  }
}

function storageRemove(win: Window, key: string): void {
  try {
    win.sessionStorage.removeItem(key);
  } catch {
    // ignore
  }
}

export function installChunkLoadErrorRecovery(win: Window = window): void {
  win.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    if (!reason || reason.name !== 'ChunkLoadError') {
      return;
    }
    if (storageGet(win, RELOAD_FLAG)) {
      // Already reloaded once for this tab; do not loop.
      return;
    }
    storageSet(win, RELOAD_FLAG, '1');
    event.preventDefault();

    if ('serviceWorker' in win.navigator) {
      win.navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
          registrations.forEach((registration) => registration.unregister());
        })
        .catch(() => undefined)
        .finally(() => win.location.reload());
    } else {
      win.location.reload();
    }
  });

  // A successful load clears the guard so a later ChunkLoadError can reload again.
  win.addEventListener('load', () => storageRemove(win, RELOAD_FLAG));
}
